/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'email': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27 6H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-1.6 2L16 16.6 6.6 8h18.8zM5 24V9.3l11 10.1L27 9.3V24H5z"/>'
  }
})
